// extracted by mini-css-extract-plugin
export default {"titleWrapper":"index_titleWrapper__wP6ij","section":"index_section__96DoZ","bold":"index_bold__Kz9ja"};